import {BaseSearchDTO} from "../baseSearchDTO.interface";

export interface ProspectSearchDTO extends BaseSearchDTO {
  filters?: {
    advertId?: string;
  };
}
